import { render, staticRenderFns } from "./TabRunningShipment.vue?vue&type=template&id=4578bbda&scoped=true"
import script from "./TabRunningShipment.vue?vue&type=script&lang=js"
export * from "./TabRunningShipment.vue?vue&type=script&lang=js"
import style0 from "./TabRunningShipment.vue?vue&type=style&index=0&id=4578bbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578bbda",
  null
  
)

export default component.exports